module.exports = __webpack_public_path__ + "static/media/image-default-user-picture.3534fd3c.svg";